/* eslint-disable react/prop-types */
/* eslint-disable no-prototype-builtins */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import ControlButton from '../../../components/common/ControlButton';
import '../../../styles/Param.scss';
import { ReactComponent as RefreshIcon } from '../../../assets/icons/refresh.svg';
import { GlobalActions } from '../../../context/actions';
import ParamForm from './ParamForm';
import { genRandNumList } from './InputBuilders';
import { commaSeparatedNumberListValidCheck } from './InputValidators';
import { errorParamMsg } from './ParamMsg';


import useParam from '../../../context/useParam';

/**
 * This list param component can be used when
 * the param input accepts a list
 */
function ListParam({
  name, buttonName, mode, DEFAULT_VAL, SET_VAL, REFRESH_FUNCTION, ALGORITHM_NAME,
  EXAMPLE, formClassName, handleSubmit, setMessage
}) {
  const {
    dispatch,
    disabled,
    // paramVal,
    // setParamVal,
  } = useParam(DEFAULT_VAL);

  /**
   * The default function that uses the list of values to
   * run an animation. It will check whether the input list
   * is valid first.
   */
  const handleDefaultSubmit = (e) => {
    e.preventDefault();
    const inputValue = e.target[0].value.replace(/\s+/g, '');
    const { valid, error } = commaSeparatedNumberListValidCheck(inputValue);

    if (valid) {
      const nodes = inputValue.split`,`.map((x) => +x);
      dispatch(GlobalActions.RUN_ALGORITHM, { name, mode, nodes });
      setMessage(null);
    } else {
      setMessage(errorParamMsg(error, EXAMPLE));
    }
  };

  return (
    <ParamForm
      formClassName={formClassName}
      name={ALGORITHM_NAME}
      buttonName={buttonName}
      value={DEFAULT_VAL}
      disabled={disabled}
      onChange={(e) => {
        // console.log(e.target.value);
        // console.log(e.target.value.split(','));
        SET_VAL(e.target.value.split(','));
      }}
      // If no customized handle function is provided, the default one will be used
      handleSubmit={
        handleSubmit && typeof handleSubmit === 'function'
          ? handleSubmit
          : handleDefaultSubmit
      }
    >
      <ControlButton
        icon={<RefreshIcon />}
        className={disabled ? 'greyRoundBtnDisabled' : 'greyRoundBtn'}
        id={ALGORITHM_NAME}
        disabled={disabled}
        onClick={() => {
          // console.log(DEFAULT_VAL);
          let list = genRandNumList(DEFAULT_VAL.length, 1, 100);

          if (REFRESH_FUNCTION !== undefined) {
            // refresh function is simply a function that returns a list, in whatever sorted (or random) order as desired
            list = REFRESH_FUNCTION();
          }
          setMessage(null);
          SET_VAL(list);
        }}
      />
    </ParamForm>
  );
}

export default ListParam;
